import { Component, Input } from '@angular/core';

import { consignacao } from '../../config-pedido-tipo-venda-indicador';

@Component({
    selector: 'sgt-config-pedido-tipo-venda-badge-consignacao',
    templateUrl: './config-pedido-tipo-venda-badge-consignacao.component.html',
    styleUrls: ['./config-pedido-tipo-venda-badge-consignacao.component.less']
})
export class ConfigPedidoTipoVendaBadgeConsignacaoComponent {
    tipo = consignacao;

    /** Se o badge deve exibir o tipo de forma abreviada */
    @Input() isAbreviacao = false;
}
